import request from '@/utils/request'

/**
 * 获取缓存监控
 */
export const getCache = () => {
    return request({
        url: '/monitor/cache'
    })
}

/**
 * 获取服务监控
 */
export const getService = () => {
    return request({
        url: '/monitor/service'
    })
}

/**
 * 获取缓存列表
 */
export const getCacheList = (id) => {
    return request({
        url: `/monitor/cache/names/${id}`
    })
}

/**
 * 获取缓存键名列表
 */
export const getCacheKeyList = (key) => {
    return request({
        url: `/monitor/cache/keys/${key}`
    })
}

/**
 * 获取缓存键值列表
 */
export const getCacheValue = (name, data) => {
    return request({
        url: `/monitor/cache/value/${name}/${data}`
    })
}

/**
 * 清空指定键的值
 */
export const delKey = (key) => {
    return request({
        url: `/monitor/cache/clear/${key}`,
        method: 'DELETE'
    })
}

/**
 * 清空指定缓存名的键值列表
 */
export const delCache = (name) => {
    return request({
        url: `/monitor/cache/clear/name/${name}`,
        method: 'DELETE'
    })
}

/**
 * 清空全部缓存
 */
export const delAllCache = () => {
    return request({
        url: '/monitor/cache/all/clear',
        method: 'DELETE'
    })
}

/**
 * 获取在线用户
 */
export const getOnline = (data) => {
    return request({
        url: '/monitor/online',
        params: data
    })
}

/**
 * 在线用户_强退
 */
export const delOnline = (id) => {
    return request({
        url: `/monitor/online/${id}`,
        method: 'DELETE'
    })
}
